$(document).ready(function() {
  var isPreCart = getParameterByName('preCart');
  var grabRawDiamondInfo = localStorage.getItem("_raw_diamond_info")
  var redirectSelectedDiamondShape = getParameterByName('diamondType'); 
  var getProductHandle = getParameterByName('productHandle');
  var getRingSize = getParameterByName('ringSize');
  var convertArray = redirectSelectedDiamondShape?.split(",");
  var lastSelectedDiamond = convertArray ? convertArray[convertArray.length - 1] : ""
  var rawDiamondInfo = JSON.parse(grabRawDiamondInfo)
  var getSelectedSetting = localStorage.getItem("selectedSettingInfo")
  var getSelectedSettingInfo = JSON.parse(getSelectedSetting)
  var isSelectWithDiamondFirst = getParameterByName('startwithsetting');
  var getSelectedProductUrl = localStorage.getItem("selectingDiamondFor") 
  
  if (rawDiamondInfo) var diaObjectData = rawDiamondInfo ? rawDiamondInfo.diamondObj.split('_') : "";

  if (rawDiamondInfo && pageTemplate !== 'select-diamond'){
    var selectedDiamondShape = rawDiamondInfo.diamondShape
    $('#diamondDetailsThreeStep').text(`${selectedDiamondShape} ${parseFloat(diaObjectData[0]).toFixed(2) + "ct"}, ${diaObjectData[1]}, ${diaObjectData[2]}, ${diaObjectData[3]} ${diaObjectData[4]}`);
    $('#selectedDiamondDetailsPpdp').text(`${selectedDiamondShape} ${parseFloat(diaObjectData[0]).toFixed(2) + "ct"}, ${diaObjectData[1]}, ${diaObjectData[2]}, ${diaObjectData[3]} ${diaObjectData[4]}`)
    $('#viewChangeDiamond').removeClass('hide');
  } else {
    $('#diamondDetailsThreeStep, #viewChangeDiamond').remove();
  }
  
  if(getSelectedSettingInfo && pageType !== 'collection' && pageType !== 'product') {
    var productPrice = parseFloat(getSelectedSettingInfo.grabProductPrice/100)
    $('#selectedSettingThreeStep').text(getSelectedSettingInfo.grabProductTitle + " " + "$" + commafy(productPrice))
    $('#viewChangeSetting').removeClass('hide')
  } else if (pageType === 'product') {
    $('#viewChangeSetting').removeClass('hide')
  } else {
    $('#selectedSettingThreeStep, #viewChangeSetting, #totalCostCalculator').remove()
  }
  
  if (rawDiamondInfo && getSelectedSettingInfo && pageType !== 'product') {
    let cleanPrice = diaObjectData[4].replace(/[$,]/g, '');
    $('#totalCostCalculator').text('Total cost: $' + commafy(parseInt(cleanPrice) + parseFloat(getSelectedSettingInfo.grabProductPrice/100)))
    $('#startOverProcess').removeClass('hide')
  } else if (pageType === 'product' && rawDiamondInfo) {
    $('#startOverProcess').removeClass('hide')
  } else {
    $('#totalCostCalculator, #startOverProcess').remove()
  }
  
  // Step Two
  if(currentCollectionTemplate !== 'vow.engagement.rings'){
    $('#chooseDiamond').click(function() {
      document.getElementById("selectDiamondPageLink").click();
    });
  }
  // Step One
  if(pageTemplate && pageTemplate === 'selectDiamond'){
    $("#chooseSettings, #viewProuctSetting").attr("onclick",`updateURLParamAndRedirect('${lastSelectedDiamond ? lastSelectedDiamond : ''}', 'false')`);
  }
  // Step Three
  if (grabRawDiamondInfo && getRingSize && isPreCart !== 'true' && currentCollectionTemplate !== 'vow.engagement.rings') {
    $("#ChooseSize").attr("onclick",`updateURLParamAndRedirect('${selectedDiamondShape ? selectedDiamondShape : ''}', 'true')`).addClass('show-hand-cursor');
    $("#confirm-diamond-feed, #confirm-diamond-feed-mobile").attr("onclick",`updateURLParamAndRedirect('${selectedDiamondShape ? selectedDiamondShape : ''}', 'true')`).addClass('show-hand-cursor');
  }
  if(isPreCart === 'true' && grabRawDiamondInfo) {
    $('#chooseSettings').addClass('show-hand-cursor')
    $('#chooseSettings').click(function() {
      document.getElementById("edit-diamond-settings").click();
    });
  } 
  /* Updating the redirecting URL for Changing Diamond */
  if(grabRawDiamondInfo) {
    var diamondType = rawDiamondInfo.diamondShape
    if(diamondType === "Antique-Style Cushion" || diamondType === "Antique Style Cushion" || diamondType === 'antiquestylecushion') diamondType = 'OldMine'
    if(diamondType === "Antique-Style Round" || diamondType === "Antique Style Round" || diamondType === 'antiquestyleround' || diamondType === 'antique-styleround') diamondType = 'European'
    if(isSelectWithDiamondFirst && isSelectWithDiamondFirst === 'true'){
      $('#changeProduct').attr('href',`/collections/ring-builder?startwithsetting=true&dp=${diamondType}`)
    } else {
      $('#changeProduct').attr('href',`/collections/ring-builder?dp=${diamondType}`)
    }
  } 
  /* Set Product Redirect URL on Diamond Compare Page */
  if(pageTemplate === 'compare-diamond' && getSelectedProductUrl){
    if (getSelectedProductUrl.includes('preCart')) {
      getSelectedProductUrl = getSelectedProductUrl.replace('preCart=true', 'preCart=false');
    }
    $('#viewProuctSetting').attr('href', getSelectedProductUrl).removeAttr('onclick');
  }
});
  
threeStepProcess();
function threeStepProcess(){
  var grabRawDiamondInfo = localStorage.getItem("_raw_diamond_info")
  var rawDiamondInfo = JSON.parse(grabRawDiamondInfo)
  var getSelectedSetting = localStorage.getItem("selectedSettingInfo")
  var selectedDiamondShape = rawDiamondInfo?.diamondShape
  var getProductHandle = getParameterByName('productHandle');
  var isSelectWithDiamondFirst = getParameterByName('startwithsetting');
  if(selectedDiamondShape === 'Antique Style Cushion') selectedDiamondShape = 'Antique-Style Cushion'
  switch (pageType) {
  case 'collection':
    $('#startOverProcess').remove();
    $('#viewChangeDiamond').remove();  
    //localStorage.removeItem("selectedSettingInfo")  
    if(grabRawDiamondInfo){
      $('#step-two-choose-setting, #step-one-choose-diamond').addClass('selected')
      $("#changeSelectedDiamondBtn").attr("onclick", `redirectToSelectedDiamondFeed('${selectedDiamondShape}', 'change')`);
      $("#viewSelectedDiamondBtn").attr("onclick", `redirectToSelectedDiamondFeed('${selectedDiamondShape}', 'view')`);
    } else {
      $('#step-two-choose-setting').addClass('selected')
    }
    /* Re-arranging if user selected- Start with setting */
    if(isSelectWithDiamondFirst && isSelectWithDiamondFirst === 'true'){
      var $stepTwo = $('#step-two-choose-setting').detach();
      $('.steplist').prepend($stepTwo);
      $('.steplist li').each(function(index) {
        var stepNumber = index + 1;
        $(this).find('.process-steps').text(stepNumber);
      });
    }  
    break;
  case 'product':
    var isPreCart = getParameterByName('preCart');  
    if(localStorage.getItem('_raw_diamond_info') && isPreCart === 'true'){
      $('#step-two-choose-setting, #step-one-choose-diamond, #step-three-review-design').addClass('selected')
    } else {
      //setTimeout(function() {
        if(grabRawDiamondInfo){
          $('#step-two-choose-setting, #step-one-choose-diamond').addClass('selected')
          $("#changeSelectedDiamondBtn").attr("onclick", `redirectToSelectedDiamondFeed('${selectedDiamondShape}', 'change')`);
          $("#viewSelectedDiamondBtn").attr("onclick", `redirectToSelectedDiamondFeed('${selectedDiamondShape}', 'view')`);
          $('#viewProuctSetting').remove()
        } else {
          $('#step-two-choose-setting').addClass('selected')
        }
      //}, 3000)
    }
    /* Re-arranging if user selected- Start with setting */
    if(isSelectWithDiamondFirst && isSelectWithDiamondFirst === 'true'){
      var $stepTwo = $('#step-two-choose-setting').detach();
      $('.steplist').prepend($stepTwo);
      $('.steplist li').each(function(index) {
        var stepNumber = index + 1;
        $(this).find('.process-steps').text(stepNumber);
      });
    }  
    break;
  case 'page':
    if(grabRawDiamondInfo && getSelectedSetting && getProductHandle){
       $('#step-two-choose-setting, #step-one-choose-diamond, #step-three-review-design').addClass('selected')
       $('#viewChangeDiamond').remove();
    } else if(!grabRawDiamondInfo && getSelectedSetting && getProductHandle) {
       $('#step-two-choose-setting, #step-one-choose-diamond').addClass('selected')
    } else {
      // if(isSelectWithDiamondFirst && isSelectWithDiamondFirst === 'true'){
        $('#step-one-choose-diamond').addClass('selected');
        $('#totalCostCalculator, #startOverProcess').remove();
      // } else {
      //   $('#step-one-choose-diamond').addClass('selected');
      //   $('#selectedSettingThreeStep, #viewChangeSetting, #totalCostCalculator, #startOverProcess').remove();
      // }
    }
    if(pageTemplate === 'selectDiamond')$('#viewChangeDiamond').remove();  
    /* Re-arranging if user selected- Start with setting */  
    if(isSelectWithDiamondFirst && isSelectWithDiamondFirst === 'true'){
      var $stepTwo = $('#step-two-choose-setting').detach();
      $('.steplist').prepend($stepTwo);
      $('.steplist li').each(function(index) {
        var stepNumber = index + 1;
        $(this).find('.process-steps').text(stepNumber);
      });
    }  
    break;
  default:
    console.log('none')
    break;
  }
}

function updateURLParamAndRedirect (shape, isPreCart){
  if (isPreCart === 'true'){
    updateURLParameter('preCart','true',shape)
    updateURLParameter('startwithsetting', 'true', shape);
  } else {
    updateURLParameter('preCart','false',shape)
    updateURLParameter('startwithsetting', 'true', shape);
  }
}

function updateURLParameter(param, value, shape) {
  var url = window.location.href;
  var regex = new RegExp('([?&])' + param + '=.*?(&|$)', 'i');
  var separator = url.indexOf('?') !== -1 ? '&' : '?';
  if (url.match(regex)) {
    url = url.replace(regex, '$1' + param + '=' + value + '$2');
  } else {
    url = url + separator + param + '=' + value;
  }
  window.history.replaceState(null, null, url);
  redirectToProductDetailPage(shape)
}

/* Redirect to selected diamond feed */
function redirectToSelectedDiamondFeed(selectedShape, action) {
  var isSelectWithDiamondFirst = getParameterByName('startwithsetting');
  var redirectString = `/pages/select-diamond?diamondType=${selectedShape}&diamondLabType=natural&selectDiamondFirst=true`
  var selectedMetal= getParameterByName("metal")
  var decodedMetal = decodeURIComponent(selectedMetal);
  var metal = decodedMetal.replace(/\s+/g, '');
  var getProductHandle = getParameterByName('productHandle');
  var diamondTag = getParameterByName("diamondTag")
  var grabRingSize = getParameterByName("ringSize")
  var preCartStatus = getParameterByName("preCart")
  var isSelectWithDiamondFirst = getParameterByName('startwithsetting');
  var grabRawDiamondInfo = localStorage.getItem("_raw_diamond_info");
  var rawDiamondInfo = JSON.parse(grabRawDiamondInfo)
  var certNumber = rawDiamondInfo ? rawDiamondInfo.certNum : "";
  
  if(metal){
    redirectString += "&metal=" + metal
  }
  if(getProductHandle){
    redirectString += "&productHandle=" + getProductHandle
  }
  if (diamondTag) {
    redirectString += "&diamondTag=" + diamondTag
  } else {
    redirectString += "&diamondTag=natural"
  }
  if(grabRingSize){
    redirectString += "&ringSize=" + grabRingSize
  }
  if (grabRawDiamondInfo && preCartStatus !== 'false') {
    redirectString += "&preCart=true"
  }
  if(isSelectWithDiamondFirst && isSelectWithDiamondFirst === 'true') {
    redirectString += "&startwithsetting=true"
  }
  if(certNumber && certNumber !== "" && action === 'view' ) {
    redirectString += "&did=" + certNumber
  }
  window.location.href= redirectString;
  if(pageType === 'product'){
    var hideMarquiseDiamond = false;
    if (currentProductJson.tags.includes('hide-marquise-diamond')) hideMarquiseDiamond = true;
    var grabProductTitle = currentProductJson.title;
    var grabProductPrice = removeDoller($('#actualSettingprice').text())*100;
    localStorage.setItem( 'selectedSettingInfo', JSON.stringify({grabProductTitle, grabProductPrice, hideMarquiseDiamond}) )
  }
}

/* Three step process: Start Over Button(Removing selected Diamond info and redirecting) */
function bespokeStartOver() {
  removeVowLocalstorageItems()
  //window.location.href = '/pages/start-with-diamonds'; //uncomment when landing page goes live
  window.location.href = '/collections/ring-builder?startwithsetting=true'
}

/* Update Setting/Total Cost Price on Three Step Process bar */
function updatePriceThreeStepProcess(grabPrice){
  var getSelectedSetting = localStorage.getItem("selectedSettingInfo")
  var getSelectedSettingInfo = JSON.parse(getSelectedSetting)
  var grabRawDiamondInfo = localStorage.getItem("_raw_diamond_info")
  var rawDiamondInfo = JSON.parse(grabRawDiamondInfo)
  var removePriceDollar = removeDoller(grabPrice)
  if (rawDiamondInfo) var diaObjectData = rawDiamondInfo ? rawDiamondInfo.diamondObj.split('_') : "";

  if(getSelectedSettingInfo && pageType !== 'collection' && pageType !== 'product') {
    $('#selectedSettingThreeStep').text(getSelectedSettingInfo.grabProductTitle + " " + grabPrice)
    $('#viewChangeSetting').removeClass('hide')
  } else if (pageType === 'product') {
    $('#selectedSettingThreeStep').text(currentProductJson.title + " " + grabPrice)
  } else {
    $('#selectedSettingThreeStep, #viewChangeSetting, #totalCostCalculator').remove()
  }
  
  let diamondPrice = (diaObjectData && diaObjectData.length >= 5 && typeof diaObjectData[4] === 'string') ? diaObjectData[4].replace(/[$,]/g, '') : '';
  if (rawDiamondInfo && getSelectedSettingInfo && pageType !== 'product') {
    $('#totalCostCalculator').text('Total cost: $' + commafy(parseInt(diamondPrice) + parseFloat(removePriceDollar)))
    $('#startOverProcess').removeClass('hide')
  } else if (pageType === 'product') {
    $('#totalCostCalculator').text('Total cost: $' + commafy(parseInt(diamondPrice) + parseFloat(removePriceDollar)))
  } else {
    $('#totalCostCalculator, #startOverProcess').remove()
  }
}